import { useCallback, useEffect } from 'react';
import { pick } from 'ramda';
import { useDeviceSelector } from 'js/store/hooks';

export const useRefreshSafari = (): void => {
    const { isDesktop, browserName } = useDeviceSelector(pick(['isDesktop', 'browserName']));
    const isNeedToRefresh = !isDesktop && browserName === 'safari';
    const refresh = useCallback((event: PageTransitionEvent): void => {
        if (event.persisted) {
            window.location.reload();
        }
    }, []);

    useEffect(() => {
        if (isNeedToRefresh) {
            window.addEventListener('pageshow', refresh);
        }

        return () => {
            if (isNeedToRefresh) {
                window.removeEventListener('pageshow', refresh);
            }
        };
    }, [isNeedToRefresh, refresh]);
};
